const getPaginatedEntityConfig = (entityName: string) => (state) => state.pagination[entityName];

export const paginationSelectors = {
  getSpaDaysPagination: getPaginatedEntityConfig('spaDays'),
  getSpaPackagesPagination: getPaginatedEntityConfig('spaPackages'),
  getSpaPackagesAllPagination: getPaginatedEntityConfig('spaPackagesAll'),
  getSpaTreatmentsPagination: getPaginatedEntityConfig('spaTreatments'),
  getFacilitiesPagination: getPaginatedEntityConfig('facilities'),
};
